import React from "react";
import Home from "@/components/Pages/Public/Home";

const HomePage: React.FC = () => {
  return <Home />;
};

export default HomePage;
